import { AUTH_TOKEN } from "constants/AuthConstant";

// Variables pour gérer l'état du refresh
let isRefreshing = false;
let refreshPromise = null;
let lastRefreshTime = 0;
const REFRESH_COOLDOWN = 5000; // 5 secondes de cooldown entre les refresh

export const refreshAccessToken = async () => {
  // Si un refresh est déjà en cours, on retourne la même promesse
  if (isRefreshing) {
    return refreshPromise;
  }

  // Vérifier si on a déjà rafraîchi récemment
  const now = Date.now();
  if (now - lastRefreshTime < REFRESH_COOLDOWN) {
    return localStorage.getItem(AUTH_TOKEN);
  }

  try {
    isRefreshing = true;
    refreshPromise = new Promise(async (resolve, reject) => {
      try {
        const BASE_URL = process.env.REACT_APP_API_URL;

        const response = await fetch(`${BASE_URL}/partners/refresh`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.message || `HTTP error! Status: ${response.status}`
          );
        }

        const data = await response.json();

        if (!data?.accessToken) {
          throw new Error("No access token in response");
        }

        localStorage.setItem(AUTH_TOKEN, data.accessToken);
        lastRefreshTime = Date.now();
        resolve(data.accessToken);
      } catch (error) {
        // En cas d'erreur, on nettoie le token et on propage l'erreur
        localStorage.removeItem(AUTH_TOKEN);
        reject(error);
      } finally {
        isRefreshing = false;
        refreshPromise = null;
      }
    });

    return await refreshPromise;
  } catch (error) {
    console.error("Échec du refresh token:", error.message);
    throw error;
  }
};

// Fonction utilitaire pour vérifier si un refresh est en cours
export const isRefreshingToken = () => isRefreshing;

// Fonction pour obtenir le dernier temps de refresh
export const getLastRefreshTime = () => lastRefreshTime;